/** Pure helpers for routing a multi-day itinerary without joining nights. */
export type DayRoutePoint = { day?: number | null };

export type DayRouteSegment = {
  day: number;
  indices: number[];
};

export function splitRouteIndicesByDay(points: readonly DayRoutePoint[]): DayRouteSegment[] {
  const segments: DayRouteSegment[] = [];
  for (let index = 0; index < points.length; index += 1) {
    const day = Math.max(1, Math.trunc(points[index]?.day ?? 1));
    const current = segments[segments.length - 1];
    if (!current || current.day !== day) segments.push({ day, indices: [index] });
    else current.indices.push(index);
  }
  return segments;
}

export function expectedDayRouteLegs(points: readonly DayRoutePoint[]): number {
  return splitRouteIndicesByDay(points).reduce(
    (total, segment) => total + Math.max(0, segment.indices.length - 1),
    0,
  );
}
